// extracted by css-extract-rspack-plugin
export default {"root":"JjmVD2","vertical":"hR3dUC","horizontal":"IKNWCr","detail":"yJOmSe"};